// extracted by mini-css-extract-plugin
module.exports = {"p__container":"Redirect_p__container__2Vl2Z","p__title":"Redirect_p__title__akiJi","p__rVieBtn":"Redirect_p__rVieBtn__2X1GS"};